// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableWrapper {\n    margin: 0 auto;\n    width: 100%;\n    font-size: 13px;\n    text-align: left;\n    margin-top: 1rem;\n    /*margin-bottom: 2rem;*/\n}\n\n@media screen and (max-width:480px) {\n    /*　画面サイズが480pxからはここを読み込む　*/\n    .tableContent {\n        white-space: pre-wrap;\n    }\n}", ""]);
// Exports
module.exports = exports;
